import { useMutation } from '@tanstack/react-query'
import { apiClient } from '@/shared/api/client'

interface PurchaseGiftCardInput {
  initialAmount: number
  recipientEmail: string
  recipientName?: string
  senderName?: string
  personalMessage?: string
  buyerEmail?: string
  returnUrl?: string
}

interface PurchaseGiftCardResponse {
  success: boolean
  data: {
    giftCardId: string
    paymentUrl: string | null
  }
}

export function usePurchaseGiftCard() {
  return useMutation({
    mutationFn: async (input: PurchaseGiftCardInput) => {
      const response = await apiClient<PurchaseGiftCardResponse>(
        '/api/user/gift-cards/purchase',
        {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(input),
          initData: 'auto', // apiClient добавит initData из Telegram WebApp
        }
      )
      return response.data
    },
  })
}
